import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "../../../fnx/showError";
export var useInsurancesErrorHandling = function (_a) {
    var errorProjects = _a.errorProjects, errorSponsors = _a.errorSponsors, errorInsuranceTypes = _a.errorInsuranceTypes, errorDelete = _a.errorDelete, setSeeToast = _a.setSeeToast;
    var t = useTranslation().t;
    useEffect(function () {
        if (errorProjects)
            showErrorToast(errorProjects, setSeeToast, t);
    }, [errorProjects]);
    useEffect(function () {
        if (errorSponsors)
            showErrorToast(errorSponsors, setSeeToast, t);
    }, [errorSponsors]);
    useEffect(function () {
        if (errorInsuranceTypes)
            showErrorToast(errorInsuranceTypes, setSeeToast, t);
    }, [errorInsuranceTypes]);
    useEffect(function () {
        if (errorDelete)
            showErrorToast(errorDelete, setSeeToast, t);
    }, [errorDelete]);
};
